import React, { Component } from 'react';
import Link from 'gatsby-link';
import logo from './../assets/img/logo.png';
// styles: nav.styl

class Nav extends Component {
  toggleMenu() {
    const hamburger = document.querySelector('.nav-hamburger');
    const menu = document.querySelector('.menu');
    const links = document.querySelectorAll('.menu a');

    hamburger.classList.toggle('nav-hamburger-open');
    menu.classList.toggle('menu-open');
    links.forEach((link) => {
      link.classList.toggle('link-open');
    });
  }
  render() {
    return (
      <div className='nav'>
          <Link to='/' exact>
            <img className='nav-logo' src={logo} />
          </Link>

          <div className='nav-hamburger' onClick={this.toggleMenu}>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
          </div>
      </div>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/nav.js